export default {
  tag: 'Test',
  tag_tooltip: 'Restaurant test : entièrement fonctionnel, jamais facturé.',
  card: {
    title: 'Restaurant test',
    description:
      "Marquez un restaurant comme restaurant test pour essayer l'impression, les e-mails, les commandes et les intégrations en production. Il fonctionne comme n'importe quel autre restaurant et n'est jamais facturé. Les e-mails et SMS clients concernant ses commandes commencent par [TEST].",
    payments_note:
      'Les paiements du restaurant test sont réels et versés comme pour tout autre. Remboursez vous-même les commandes de test. Nous sommes notifiés lorsque ses ventes mensuelles dépassent le cadre des tests.',
    designated_on: 'Marqué comme test le {{date}}',
    open_shop: 'Ouvrir la boutique',
    remove: 'Retirer la désignation Test',
    select_placeholder: 'Choisissez un restaurant',
    mark: 'Marquer comme restaurant test',
    no_restaurants: "Vous n'avez aucun restaurant à marquer pour l'instant.",
    load_error: "Votre restaurant test n'a pas pu être chargé.",
  },
  remove_confirm: {
    title: 'Retirer la désignation Test de {{name}} ?',
    description_live:
      'La facturation de ce restaurant reprend et il passe hors ligne immédiatement. Relancez-le depuis Paramètres de commande → Modes de commande → Commandes en direct, où vous choisissez son forfait.',
    description_stays_live:
      'Ce restaurant reste actif et est à nouveau traité comme vos autres restaurants à partir de maintenant.',
    description_offline:
      "La facturation de ce restaurant reprend dès qu'il passe en direct. Son forfait est choisi au moment du lancement.",
    confirm: 'Retirer la désignation Test',
  },
  toasts: {
    designated: "{{name}} est maintenant votre restaurant test. Il n'est pas facturé.",
    designate_error: "Le restaurant n'a pas pu être marqué comme test. Veuillez réessayer.",
    removed: "{{name}} n'est plus votre restaurant test.",
    removed_offline: "{{name}} n'est plus votre restaurant test et est maintenant hors ligne.",
    remove_error: "La désignation Test n'a pas pu être retirée. Veuillez réessayer.",
  },
};
